import React, { createContext, useState, useEffect, useContext } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { OktaAuth } from '@okta/okta-auth-js'
import { oktaConfig } from '../Config/OktaConfig'
import CssApiClient from '../Components/Api'

const oktaAuth = new OktaAuth(oktaConfig)

const UserContext = createContext(null)

export const UserProvider = ({ children }) => {
  const { authState } = useOktaAuth()
  const [user, setUser] = useState(null)

  useEffect(() => {
    const fetchUser = async () => {
      if (authState?.isAuthenticated && !user) {
        const userInfo = await oktaAuth.getUser()
        setUser(userInfo)
        CssApiClient.setUserInfo(userInfo)
        try {
          await CssApiClient.postLog(
            {
              userId: userInfo.sub,
              email: userInfo.email,
              userAction: 'LOGIN_SUCCESS',
              errorMessage: null,
              statusCode: 200,
              name: userInfo?.name || 'UNKNOWN',
              job_profile: userInfo?.job_profile || 'UNKNOWN'
            },
            ''
          )
        } catch (err) {
          console.error('Failed to send login log', err)
        }
      }
    }
    fetchUser()
  }, [authState, user])

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>
}

export const useUser = () => useContext(UserContext)
